import React from "react";

const FormattedDate = ({ dateString }) => {
  const formatted = new Date(dateString).toLocaleString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });

  return <span>{formatted}</span>;
};

export default FormattedDate;
